import axios from 'axios';
import { getTokenForUser } from '../utils/helpers';

axios.defaults.headers.common['Content-type'] = 'application/json';
axios.defaults.baseURL = process.env.REACT_APP_API_URL || '';

const logPageView = (logEntry, user) =>{
  if(getTokenForUser(user) != null)
  {
    return axios.post(
        '/api/analytics',
        logEntry,
        {
          headers: { Authorization: `Bearer ${user.access_token}` },
        },
        { timeout: 1000 }
      );
  }
}
const verifyPreviewAccess = (token) =>
  axios.get('/api/preview/brief/checkaccess', {
    headers: { Authorization: `Bearer ${token}` },
  });

const fetchBriefs = (pageNumber, pageSize, token, usePreview = true) =>
  axios.get(    
    `/api/${usePreview ? 'preview/' : ''
    }brief/getbriefs/?pageNumber=${pageNumber}&pageSize=${pageSize}&sortBy=sys.updatedAt&sortOrder=desc
`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );

const fetchBrief = (uniqueId, token, usePreview = true) =>
  axios.get(
    `/api/${usePreview ? 'preview/' : ''}brief/getByUniqueId/${uniqueId}
`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );

const fetchBriefHeader = (uniqueId, usePreview) =>
  axios.get(
    `/api/${usePreview ? 'preview/' : ''}public/getbriefheader/${uniqueId}`
  );

const fetchPage = (slug, user = null, usePreview = false) => {
  if (user !== null && user.access_token !== null && usePreview) {
    return axios.get(`/api/pages/preview/${slug}`, {
      headers: { Authorization: `Bearer ${user.access_token}` },
    });
  }
  return axios.get(`/api/pages/${slug}`);
};

const fetchRecentUpdates = (
  token,
  start,
  end,
  searchDirection = 'date',
  numDays = 30
) => {
  if (token !== null) {
    return axios.get(
      `/api/search/newcontent/?d=${numDays}&sort=${searchDirection}&s=${start}&e=${end}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
  }
  else {
    return axios.get(
      `/api/search/newcontentlimited/?d=${numDays}&sort=${searchDirection}&s=${start}&e=${end}`
    );
  }
}

const searchOrganizationByNameForAnalytics = (user = null, searchTerm) => {
  if (user !== null && user.access_token !== null && searchTerm.length > 0) {
    return axios.get(
      `/api/analytics/searchprimaryorganizations/?StartsWith=${searchTerm}`,
      { headers: { Authorization: `Bearer ${user.access_token}` } }
    );
  }
};

const fetchFileExport = (user = null, exportPayload) => {
  return axios.post(`/api/export`, exportPayload)
};

const fetchAnalyticsReport = (
  user = null,
  exportOnly = false,
  orgId,
  startDate,
  endDate
) => {
  if (user !== null && user.access_token !== null && orgId.length > 0) {
    if (!exportOnly) {
      return axios.get(
        `/api/analytics/getanalytics/?PrimaryOrganizationId=${orgId}&StartDate=${startDate}&EndDate=${endDate}`,
        { headers: { Authorization: `Bearer ${user.access_token}` } }
      );
    } else {
      return axios.get(
        `/api/analytics/exporttoexcel/?PrimaryOrganizationId=${orgId}&StartDate=${startDate}&EndDate=${endDate}`,
        {
          headers: {
            Authorization: `Bearer ${user.access_token}`,
          },
          responseType: 'blob',
        }
      );
    }
  }
};

const fetchRegistrationLog = (user, startDate, endDate, startIndex, size) => {
  if (
    user !== null &&
    user.access_token !== null &&
    startDate &&
    endDate &&
    size > 0
  ) {
    const request = {
      startIndex: startIndex,
      size: size,
      Query: {
        startDate: startDate,
        endDate: endDate,
      },
    };

    return axios.post(`/api/user/GetRegistrationLog`, request, {
      headers: { Authorization: `Bearer ${user.access_token}` },
    });
  }
};

const fetchRegistrationTimeline = (user, startDate, endDate, email) => {
  if (
    user !== null &&
    user.access_token !== null &&
    startDate &&
    endDate &&
    email
  ) {
    const request = {
      Query: {
        email: email,
        startDate: startDate,
        endDate: endDate,
      },
    };

    return axios.post(`/api/user/GetRegistrationTimeline`, request, {
      headers: { Authorization: `Bearer ${user.access_token}` },
    });
  }
};

const fetchUserProfile = (user, email) => {
  if (user !== null && user.access_token !== null && email) {
    return axios.get(`/api/user/GetUserProfile?email=${email}`, {
      headers: { Authorization: `Bearer ${user.access_token}` },
    });
  }
};

const refineRecentUpdateSearch = (
  filters,
  token,
  start = 0,
  end = 9,
  numDays = 30
) => {
  const refiners = {
    systematicReviewCriteria: filters.systematicReviews.map((x) => ({
      id: x.key.id,
      selected: x.selected,
    })),
    guidelineQualityCriteria: filters.guidelineQuality.map((x) => ({
      id: x.key.id,
      selected: x.selected,
    })),
    guidelineRateQualityCriteria: filters.guidelineRateQuality.map((x) => ({
      id: x.key.id,
      selected: x.selected,
    })),
    inclusionCriteria: filters.inclusions.map((x) => ({
      id: x.key.id,
      selected: x.selected,
    })),
    organization: filters.organizations.map((x) => ({
      id: x.key.id,
      selected: x.selected,
    })),
    intervention: filters.interventions.map((x) => ({
      id: x.key.id,
      selected: x.selected,
    })),
    clinicalArea: filters.clinicalAreas.map((x) => ({
      id: x.key.id,
      selected: x.selected,
    })),
    patientAge: filters.patientAges.map((x) => ({
      id: x.key.id,
      selected: x.selected,
    })),
    publicationYear: Object.keys(filters.pubYears).map((k) => ({
      Id: k,
      selected: filters.pubYears[k].selected,
    })),
  };

  if (token !== null) {
    return axios.post(
      `/api/search/newcontent?d=${numDays}&sort=date&s=${start}&e=${end}`,
      refiners,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  }
  else {
    return axios.post(
      `/api/search/newcontentlimited?d=${numDays}&sort=date&s=${start}&e=${end}`,
      refiners
    );
  }
};

const searchBriefs = (
  searchPhrase,
  token,
  searchDirection = 'relevance',
  start = 0,
  end = 9
) => {
  if (token !== null) {
    return axios.get(
      `/api/search/briefs?q=${encodeURIComponent(
        searchPhrase
      )}&sort=${searchDirection}&s=${start}&e=${end}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
  }
  else {
    return axios.get(
      `/api/public/briefs?q=${encodeURIComponent(
        searchPhrase
      )}&sort=${searchDirection}&s=${start}&e=${end}`      
    );
  }
};

const refineSearchBriefs = (
  searchPhrase,
  filters,
  token,
  searchDirection = 'relevance',
  start = 0,
  end = 9
) => {
  const refiners = {
    systematicReviewCriteria: (filters.systematicReviews || []).map((x) => ({
      id: x.key.id,
      selected: x.selected,
    })),
    guidelineQualityCriteria: (filters.guidelineQuality || []).map((x) => ({
      id: x.key.id,
      selected: x.selected,
    })),
    guidelineRateQualityCriteria: (filters.guidelineRateQuality || []).map((x) => ({
      id: x.key.id,
      selected: x.selected,
    })),
    inclusionCriteria: (filters.inclusions || []).map((x) => ({
      id: x.key.id,
      selected: x.selected,
    })),
    organization: (filters.organizations || []).map((x) => ({
      id: x.key.id,
      selected: x.selected,
    })),
    intervention: (filters.interventions || []).map((x) => ({
      id: x.key.id,
      selected: x.selected,
    })),
    clinicalArea: (filters.clinicalAreas || []).map((x) => ({
      id: x.key.id,
      selected: x.selected,
    })),
    patientAge: (filters.patientAges || []).map((x) => ({
      id: x.key.id,
      selected: x.selected,
    })),
    publicationYear: Object.keys(filters.pubYears || {}).map((k) => ({
      Id: k,
      selected: filters.pubYears[k].selected,
    })),
  };
  if (token !== null) {
    return axios.post(
      `/api/search/briefs?q=${encodeURIComponent(
        searchPhrase
      )}&sort=${searchDirection}&s=${start}&e=${end}`,
      refiners,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  }
  else {
    return axios.post(
      `/api/public/briefs?q=${encodeURIComponent(
        searchPhrase
      )}&sort=${searchDirection}&s=${start}&e=${end}`,
      refiners
    );
  }
};

const requestAccess = (email) =>
  axios.get(
    `/api/registration/requestaccess?email=${encodeURIComponent(email)}`
  );

const submitNewUser = (userData) =>
  axios.post('/api/registration/newuserrequest', userData);

const confirmNewUser = (confirmationData) =>
  axios.post('/api/registration/newuserconfirm', confirmationData);

const registerMember = (token) =>
  axios.put(
    '/api/registration/existingmember',
    {},
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );

const updateLastLoginDate = (user) =>
  axios.post(
    '/api/user/UpdateLastLoginDate',
    {},
    {
      headers: { Authorization: `Bearer ${user.access_token}` },
    }
  );

const fetchAutoSuggestTitleQuery = (user = null, searchTerm) => {
  if (user !== null && user.access_token !== null && searchTerm.length > 0) {
    return axios.get(`/api/umls/SearchBriefTitles?StartsWith=${searchTerm}`, {
      headers: { Authorization: `Bearer ${user.access_token}` },
    });
  }
};

const fetchGuidelineReport = (user = null, uniqueId, guidelineTitle) => {
  if (
    user !== null &&
    user.access_token !== null &&
    guidelineTitle.length > 0
  ) {
    return axios.get(`/api/umls/GetBriefByTitle?title=${guidelineTitle}`, {
      headers: { Authorization: `Bearer ${user.access_token}` },
    });
  } else if (
    user !== null &&
    user.access_token !== null &&
    uniqueId.length > 0
  ) {
    return axios.get(`/api/umls/GetBriefById/${uniqueId}`, {
      headers: {
        Authorization: `Bearer ${user.access_token}`,
      },
    });
  }
};

const saveGuidelineIndexingQuery = (
  guidelineId,
  guidelineTitle,
  guidelineStatus,
  terms,
  indexingStatus,
  active,
  user = null,
  isUpdate
) => {
  let umlsIndexing = {
    GuidelineId: guidelineId,
    GuidelineTitle: guidelineTitle,
    GuidelineStatus: guidelineStatus,
    Terms: terms,
    IndexingStatus: indexingStatus,
    Active: active,
    UpdatedBy: user.profile.email,
    IsUpdate: isUpdate,
  };
  if (user != null && user.access_token != null) {
    return axios.post(`/api/umls/SaveIndexing`, umlsIndexing, {
      headers: { Authorization: `Bearer ${user.access_token}` },
    });
  }
};

const fetchIndexingReport = (user = null, guidelineId) => {
  if (user != null && user.access_token != null) {
    return axios.get(`/api/umls/GetIndexing/${guidelineId}`, {
      headers: { Authorization: `Bearer ${user.access_token}` },
    });
  }
};

const fetchTermsReport = (user = null, guidelineId) => {
  if (user != null && user.access_token != null) {
    return axios.get(`/api/umls/GetTerms/${guidelineId}`, {
      headers: { Authorization: `Bearer ${user.access_token}` },
    });
  }
};

const SearchUMLSTermsQuery = (user = null, term, cui, pageNumber) => {
  if (user !== null && user.access_token !== null && term.length > 0) {
    return axios.get(
      `/api/umls/SearchUMLSTerms?input=${term}&pageNumber=${pageNumber}`,
      {
        headers: { Authorization: `Bearer ${user.access_token}` },
      }
    );
  } else if (user !== null && user.access_token !== null && cui.length > 0) {
    return axios.get(`/api/umls/SearchUMLSCui?cui=${cui}`, {
      headers: { Authorization: `Bearer ${user.access_token}` },
    });
  }
};

const SearchUMLSCuiQuery = (user = null, cui) => {
  if (user !== null && user.access_token !== null && cui.length > 0) {
    return axios.get(`/api/umls/SearchUMLSCui?cui=${cui}`, {
      headers: { Authorization: `Bearer ${user.access_token}` },
    });
  }
};

const saveTermsQuery = (term, vocabulary, cui, active, user = null) => {
  let umlsTerms = {
    Term: term,
    Vocabulary: vocabulary,
    CUI: cui,
    Active: active,
    UpdatedBy: user.profile.email,
  };
  if (user != null && user.access_token != null) {
    return axios.post(`/api/umls/SaveTerms`, umlsTerms, {
      headers: { Authorization: `Bearer ${user.access_token}` },
    });
  }
};

const saveIndexingTermsQuery = (guidelineId, terms, user = null, isChecked) => {
  let umlsIndexingTerms = {
    GuidelineId: guidelineId,
    Terms: terms,
    User: user.profile.email,
    IsChecked: isChecked,
  };
  if (user != null && user.access_token != null) {
    return axios.post(`/api/umls/SaveIndexingTerms`, umlsIndexingTerms, {
      headers: { Authorization: `Bearer ${user.access_token}` },
    });
  }
};

const saveUmlsAuditTrailQuery = (guidelineId, active, user = null) => {
  let umlsAuditTrail = {
    GuidelineId: guidelineId,
    Active: active,
    UpdatedBy: user.profile.email,
  };
  if (user != null && user.access_token != null) {
    return axios.post(`/api/umls/InsertUmlsAuditTrail`, umlsAuditTrail, {
      headers: { Authorization: `Bearer ${user.access_token}` },
    });
  }
};

const SearchUMLSAtomsQuery = (user = null, cui) => {
  if (user !== null && user.access_token !== null && cui.length > 0) {
    return axios.get(`/api/umls/SearchUMLSAtoms?cui=${cui}`, {
      headers: { Authorization: `Bearer ${user.access_token}` },
    });
  }
};

const getHomePageClinicalAreas = (start, size, previewMode, onlyLogos) =>
  axios.get(
    `/api/content/getClinicalAreas?previewMode=${previewMode}&start=${start}&size=${size}&onlyLogos=${onlyLogos}`
  );

const getHomePageOrganizations = (start, size, previewMode, onlyLogos) =>
  axios.get(
    `/api/content/getOrganizations?previewMode=${previewMode}&start=${start}&size=${size}&onlyLogos=${onlyLogos}`
  );

const getHomePageNewsAndEvents = (previewMode) =>
  axios.get(`/api/content/getnewsandevents?previewMode=${previewMode}`);

const UMLSIndexingNotification = (
  guidelineId,
  guidelineTitle,
  indexingStatus,
  user = null
) => {
  let umlsNotif = {
    GuidelineId: guidelineId,
    GuidelineTitle: guidelineTitle,
    IndexingStatus: indexingStatus,
    UpdatedBy: user.profile.email,
  };
  if (user != null && user.access_token != null) {
    return axios.post(`/api/email/UMLSIndexingNotification`, umlsNotif, {
      headers: { Authorization: `Bearer ${user.access_token}` },
    });
  }
};

const getAuthenticatedUserRoles = (user) => {
  if (user != null && user.access_token != null) {
    return axios.get(`/api/user/GetAuthenticatedUserRoles`, {
      headers: { Authorization: `Bearer ${user.access_token}` },
    });
  }
};

const getUserRoles = (user, email) => {
  if (user != null && user.access_token != null) {
    return axios.get(`/api/user/GetUserRoles?email=${email}`, {
      headers: { Authorization: `Bearer ${user.access_token}` },
    });
  }
};

const getGuidelineRoles = (user) => {
  if (user != null && user.access_token != null) {
    return axios.get(`/api/user/GetRoles`, {
      headers: { Authorization: `Bearer ${user.access_token}` },
    });
  }
};

const removeUserRole = (user, roleRequest) => {
  if (user != null && user.access_token != null) {
    return axios.post(
      `/api/user/removeUserRole`,

      roleRequest,

      {
        headers: { Authorization: `Bearer ${user.access_token}` },
      }
    );
  }
};

const assignUserRole = (user, roleRequest) => {
  if (user != null && user.access_token != null) {
    return axios.post(
      `/api/user/assignUserRole`,

      roleRequest,

      {
        headers: { Authorization: `Bearer ${user.access_token}` },
      }
    );
  }
};

const fetchContentfulExport = (user = null) => {
  if (user != null && user.access_token != null) {
    return axios.get(`/api/export/exportcontentful`, {
      headers: { Authorization: `Bearer ${user.access_token}` },
      responseType: 'blob',
    });
  }
};

const getGuidelineIndex = (startIndex = 0, size = 10) => {
  let apiPayload = {
    StartIndex: startIndex,
    Size: size,
    Query: '',
  };

  return axios.post(`/api/public/getbriefheaders`, apiPayload);
};

export {
  searchOrganizationByNameForAnalytics,
  fetchAnalyticsReport,
  fetchBriefs,
  fetchBrief,
  fetchRecentUpdates,  
  refineRecentUpdateSearch,
  searchBriefs,
  refineSearchBriefs,
  logPageView,
  verifyPreviewAccess,
  requestAccess,
  submitNewUser,
  registerMember,
  confirmNewUser,
  fetchPage,
  fetchFileExport,
  updateLastLoginDate,
  fetchAutoSuggestTitleQuery,
  fetchGuidelineReport,
  saveGuidelineIndexingQuery,
  fetchIndexingReport,
  fetchTermsReport,
  SearchUMLSTermsQuery,
  SearchUMLSCuiQuery,
  saveTermsQuery,
  saveIndexingTermsQuery,
  saveUmlsAuditTrailQuery,
  SearchUMLSAtomsQuery,
  getHomePageClinicalAreas,
  getHomePageNewsAndEvents,
  getHomePageOrganizations,
  UMLSIndexingNotification,
  getUserRoles,
  getGuidelineRoles,
  removeUserRole,
  assignUserRole,
  getAuthenticatedUserRoles,
  fetchContentfulExport,
  fetchRegistrationLog,
  fetchRegistrationTimeline,
  fetchUserProfile,
  getGuidelineIndex,
  fetchBriefHeader,
};
